<template>
  <div class="d-flex flex-column items-center mt-12 mb-7">
    <RegisterCandidateForm
      :description="$tCandidateForm('Register candidate public page description')"
      :use-additional-questions="false"
      :custom-titles="customTitles"
      :register-candidate-function="registerCandidate"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import RegisterCandidateForm from '../components/register-candidate/RegisterCandidateForm';

export default {
  name: 'RegisterCandidatePage',
  components: {
    RegisterCandidateForm,
  },
  data() {
    return {
      customTitles: {
        phone: this.$tCandidateForm('Enter phone number with Viber'),
      },
    };
  },
  methods: {
    ...mapActions('user', [
      'loginByPhoneAndCode',
      'loginByToken',
    ]),
    async registerCandidate(formData) {
      try {
        const { data } = await this.$store.dispatch('candidate/register/register', formData);
        if (data) {
          const redirectUrl = data.data?.redirect_url;
          await this.loginByToken({ token: data.data.token });
          await this.successfullyRegistered({ redirectUrl });
        }
      } catch (e) {
        if (e.response?.data.message === 'Need SMS Code') {
          const redirectUrl = e.response.data.data.redirect_url;
          this.$vModal.open('enter-code', {
            onSubmit: this.onCodeSubmit.bind(this, redirectUrl, formData.phone),
          });
        } else throw e;
      }
    },
    async onCodeSubmit(redirectUrl, phone, code) {
      const sendData = { phone, code, user_type: 1 };
      await this.loginByPhoneAndCode({ sendData });
      this.$vModal.close('enter-code');
      this.successfullyRegistered({ redirectUrl });
    },
    successfullyRegistered({ redirectUrl }) {
      const url = new URL(redirectUrl);
      const urlPath = `${url.pathname}${url.searchParams ? '?' + url.searchParams : ''}${url.hash}`;
      setTimeout(() => {
        this.$router.push(urlPath);
      }, 1000);
    },
  },
};
</script>
